import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectStyles } from 'injectStyles';
import classNames from 'classnames';
import toKebabCase from 'util/toKebabCase';
import { navigationEvents } from 'analytics';
import NavigationItem from './NavigationItem';
import { navItemMobile, navItem } from '../navigationStyles';
import NavigationLink from '../../NavigationLink';
import { isHuawei } from 'util/device';

class SingleNavigationItem extends PureComponent {
  static defaultProps = {
    hasSmallDesktopMenu: false,
    isNew: false,
    pageUrl: '',
    pageLink: null,
    navIsExpanded: false,
    isCollapsible: false,
  };

  static propTypes = {
    id: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    // Note: we need the location prop.
    // When the location prop changes, this re-renders and become active/inactive
    // eslint-disable-next-line react/no-unused-prop-types
    location: PropTypes.object.isRequired,
    hasSmallDesktopMenu: PropTypes.bool,
    isNew: PropTypes.bool,
    classes: PropTypes.object.isRequired,
    pageUrl: PropTypes.string,
    pageLink: PropTypes.object,
    navIsExpanded: PropTypes.bool,
    isCollapsible: PropTypes.bool,
  };

  render() {
    const {
      id,
      icon,
      title,
      classes,
      hasSmallDesktopMenu,
      pageUrl,
      pageLink,
      isNew,
      navIsExpanded,
      isCollapsible,
    } = this.props;

    if (isHuawei && pageLink && pageLink.slug === 'juke-app') {
      return null;
    }

    return (
      <NavigationLink
        className={classNames(classes.navItem, {
          [classes.staticNav]: !isCollapsible,
          [classes.collabsibleNavItem]: isCollapsible,
          [classes.smallNavItem]: hasSmallDesktopMenu,
        })}
        source={navigationEvents.mainNav}
        data-testid={`primary-nav-${toKebabCase(id)}`}
        pageLink={pageLink}
        pageUrl={pageUrl}
        title={navItem.title}
      >
        <NavigationItem
          icon={icon}
          title={title}
          isNew={isNew}
          hasSmallDesktopMenu={hasSmallDesktopMenu}
          navIsExpanded={navIsExpanded}
          isCollapsible={isCollapsible}
        />
      </NavigationLink>
    );
  }
}

const styles = (theme) => ({
  navItem: {
    ...navItem,

    borderBottom: `solid 1px ${theme.palette.navigation.border}`,
    '&:hover,&:active': {
      backgroundColor: theme.palette.navigation.background,
      color: theme.palette.navigation.colorActive,
    },
    '&.active': {
      color: theme.palette.navigation.colorActive,
      '&::before': {
        backgroundColor: theme.palette.navigation.highlight,
      },
    },
    '&:focus': {
      borderBottom: `solid 1px ${theme.palette.navigation.border}`,
    },
  },

  collabsibleNavItem: {
    paddingLeft: 4,
    paddingRight: 4,
  },
  smallNavItem: {
    '&:before': {
      width: 4,
    },
  },
  staticNav: {},
  [theme.breakpoints.down('sl')]: {
    staticNav: {
      ...navItemMobile,
    },
  },
});

export default injectStyles(styles)(SingleNavigationItem);
